import { useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import MeaPageTitle from "../../../components/MeaPageTitle";
import MeaPageHeader from "../../../components/MeaPageHeader";
import membersAPI from "../../../services/members";
import MemberDetailComponent from "./components/MemberDetailComponent";
import MemberDetailAvatarComponent from "./components/MemberDetailAvatarComponent";
import MemberDetailExtraComponent from "./components/MemberDetailExtraComponent";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import UpdateMemberModal from "./components/UpdateMemberModal";
import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import UpdateMemberAvatarModal from "./components/UpdateMemberAvatarModal";
import UpdateMemberRolesModal from "./components/UpdateMemberRolesModal";
import { TabMenu } from "primereact/tabmenu";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import MemberRegistrationsListComponent from "./components/MemberRegistrationsListComponent";
import { PERMISSION_SCHOOL_MEMBERS } from "../../../permissions";
import { BreadCrumb } from "primereact/breadcrumb";
import MeaLink from "../../../components/MeaLink";
import { useAuthContext } from "../../../hooks/useAuthContext";
import MemberMailsComponent from "./components/MemberMailsComponent";

export function MemberDetailPage() {
  const { currentMembership, hasPermission } = useAuthContext();
  //

  const params = useParams();
  const schoolId = params.schoolId || currentMembership?.school?.id;
  const accessToken = "";
  //
  const updateModalRef = useRef();
  const updateRolesModalRef = useRef()
  const updateAvatarModalRef = useRef();
  const toast = useRef();
  const memberId = params.memberId;
  //
  const memberQuery = membersAPI.GetOne(schoolId, accessToken, memberId);
  const memberObj = memberQuery?.data?.data;
  //
  const [activeTab, setActiveTab] = useState(0);
  const canUpdateMember = hasPermission(PERMISSION_SCHOOL_MEMBERS.UPDATE);

  const openUpdateAvatarModal = () => {
    if (updateAvatarModalRef.current) {
      updateAvatarModalRef.current.show(() => {
        memberQuery.refetch();
      });
    }
  };

  const tabs = [
    { label: "Inscriptions", icon: "pi pi-user" },
    { label: "Emails", icon: "pi pi-envelope" },

  ];
  //
  const breadcrum = [

    {
      template: () => <MeaLink to={`/school/${schoolId}/admin`} icon="pi pi-home" isRipple={true}>{currentMembership?.school?.name}</MeaLink>
    },
    {
      template: () => <MeaLink to={`/school/${schoolId}/admin/members`} isRipple={true}>Membres</MeaLink>
    },
    { label: 'Détail membre' }
  ];
  //
  return (
    <>
      <MeaPage
        title={
          <MeaPageTitle
            prefix={"Membre:"}
            title={
              memberObj?.name ||
              memberObj?.lastname + " " + memberObj?.firstname
            }
          />
        }
        breadcrumb={<BreadCrumb model={breadcrum} />}
        showBackButton={true}
        actions={[
          {
            label: "Modifier le profile",
            icon: "pi pi-file-edit",
            disable: !canUpdateMember,
            command: () => {
              if (updateModalRef.current) {
                updateModalRef.current.show(() => {
                  memberQuery.refetch();
                });
              }
            },
          },
          {
            label: "Modifier les roles",
            icon: "pi pi-sitemap",
            disable: !canUpdateMember,
            command: () => {
              if (updateRolesModalRef.current) {
                updateRolesModalRef.current.show(() => {
                  memberQuery.refetch();
                });
              }
            },
          },
          {
            separator: true,
            disable: !canUpdateMember,
          },
          {
            label: "Changer l'image",
            icon: "pi pi-image",
            disable: !canUpdateMember,
            command: openUpdateAvatarModal,
          },
          {
            label: "Supprimer l'image",
            icon: "pi pi-times",
            disable: !canUpdateMember,
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment supprimer l'image de ce membre?",
                header: 'Confirmation',
                icon: 'pi pi-info-circle',
                defaultFocus: 'reject',
                acceptClassName: 'p-button-danger',
                acceptLabel: "Oui",
                rejectLabel: "Non",
                accept: () => {
                  membersAPI.DeleteAvatar(schoolId, accessToken, memberId)
                    .then(data => {
                      toast.current.show({ severity: 'success', summary: 'Succès', detail: memberObj?.name + " Retiré!", life: 3000 });
                      memberQuery.refetch();
                    })
                    .catch(error => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur de suppression!",
                      });
                    });
                },
              })
            },
          },
          {
            separator: true,
            disable: !canUpdateMember,
          },
          {
            label: "Ré/inviter à l'école",
            icon: "pi pi-sync",
            disable: !hasPermission(PERMISSION_SCHOOL_MEMBERS.DELETE),
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment ré/inviter ce membre à se connecter à l'école?",
                header: 'Confirmation',
                icon: 'pi pi-info-circle',
                defaultFocus: 'reject',
                acceptClassName: 'p-button-danger',
                acceptLabel: "Oui",
                rejectLabel: "Non",
                accept: () => {
                  membersAPI.Invite(schoolId, accessToken, memberId)
                    .then(data => {
                      toast.current.show({ severity: 'success', summary: 'Succès', detail: memberObj?.name + " Ré-inviter!", life: 3000 });
                      memberQuery.refetch();
                    })
                    .catch(error => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur!",
                      });
                    });
                },
              })
            }
          },
          {
            separator: true,
            disable: !canUpdateMember,
          },
          {
            label: "Retirer la connexion à l'école",
            icon: "pi pi-trash",
            disable: !hasPermission(PERMISSION_SCHOOL_MEMBERS.DELETE),
            command: () => {
              confirmDialog({
                message: "Voulez-vous vraiment retirer la connexion de ce membre à l'école?",
                header: 'Confirmation',
                icon: 'pi pi-info-circle',
                defaultFocus: 'reject',
                acceptClassName: 'p-button-danger',
                acceptLabel: "Oui",
                rejectLabel: "Non",
                accept: () => {
                  membersAPI.DeleteInvite(schoolId, accessToken, memberId)
                    .then(data => {
                      toast.current.show({ severity: 'success', summary: 'Succès', detail: memberObj?.name + " Connexion retirée!", life: 3000 });
                      memberQuery.refetch();
                    })
                    .catch(error => {
                      toast.current.show({
                        severity: "error",
                        summary: "Erreur",
                        detail: "Erreur!",
                      });
                    });
                },
              })
            }
          },
        ]}
      >

        <UpdateMemberModal ref={updateModalRef} member={memberObj} schoolId={schoolId} />
        <UpdateMemberRolesModal ref={updateRolesModalRef} member={memberObj} />
        <UpdateMemberAvatarModal ref={updateAvatarModalRef} member={memberObj} />
        <ConfirmDialog />
        <Toast ref={toast} position="bottom-center" />

        <MeaPageHeader>
          <MemberDetailComponent member={memberObj} />
          <MemberDetailExtraComponent member={memberObj} />
          <MemberDetailAvatarComponent
            member={memberObj}
            canEditAvatar={canUpdateMember}
            onEditAvatar={openUpdateAvatarModal}
          />
        </MeaPageHeader>
        <div className="mt-5">
          <TabMenu
            model={tabs}
            activeIndex={activeTab}
            onTabChange={(e) => setActiveTab(e.index)} />
          {activeTab === 0 && (<>
            <MeaLoadingContent objectQuery={memberQuery}>
              <MemberRegistrationsListComponent member_id={memberObj?.id} schoolId={schoolId} />
            </MeaLoadingContent>
          </>)}
          {activeTab === 1 && (<>
            <MeaLoadingContent objectQuery={memberQuery}>
              <MemberMailsComponent schoolId={schoolId} memberId={memberObj?.id} />
            </MeaLoadingContent>
          </>)}
        </div>
      </MeaPage>
    </>
  );
};
